import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContentLibrary = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const contentItems = [
    {
      id: 1,
      title: 'Residencial 3 Volcanes - Vista Aérea',
      category: 'images',
      type: 'Imagen',
      size: '2.4 MB',
      approved: true,
      url: '/assets/images/no_image.png'
    },
    {
      id: 2,
      title: 'Programa de Referidos - Banner',
      category: 'promotional',
      type: 'Banner',
      size: '1.8 MB',
      approved: true,
      url: '/assets/images/no_image.png'
    },
    {
      id: 3,
      title: 'Planos Interactivos - Demo',
      category: 'videos',
      type: 'Video',
      size: '15.2 MB',
      approved: true,
      url: '/assets/images/no_image.png'
    },
    {
      id: 4,
      title: 'Testimonios de Clientes',
      category: 'testimonials',
      type: 'Texto',
      size: '45 KB',
      approved: true,
      url: '/assets/images/no_image.png'
    },
    {
      id: 5,
      title: 'Amenidades del Proyecto',
      category: 'images',
      type: 'Imagen',
      size: '3.1 MB',
      approved: true,
      url: '/assets/images/no_image.png'
    },
    {
      id: 6,
      title: 'Promoción Especial Enero',
      category: 'promotional',
      type: 'Banner',
      size: '2.0 MB',
      approved: false,
      url: '/assets/images/no_image.png'
    }
  ];

  const categories = [
    { value: 'all', label: 'Todos', icon: 'Grid' },
    { value: 'images', label: 'Imágenes', icon: 'Image' },
    { value: 'videos', label: 'Videos', icon: 'Video' },
    { value: 'promotional', label: 'Promocionales', icon: 'Megaphone' },
    { value: 'testimonials', label: 'Testimonios', icon: 'MessageSquare' }
  ];

  const filteredContent = selectedCategory === 'all'
    ? contentItems
    : contentItems?.filter(item => item?.category === selectedCategory);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="card p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h2 className="text-xl font-semibold text-foreground flex items-center">
              <Icon name="FolderOpen" size={24} className="mr-2 text-primary" />
              Biblioteca de Contenido
            </h2>
            <p className="text-sm text-muted-foreground mt-1">
              Materiales pre-aprobados para campañas de marketing
            </p>
          </div>
          <Button iconName="Upload">
            Subir Contenido
          </Button>
        </div>
      </div>

      {/* Category Filter */}
      <div className="flex space-x-2 overflow-x-auto pb-2">
        {categories?.map((category) => (
          <button
            key={category?.value}
            onClick={() => setSelectedCategory(category?.value)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap ${
              selectedCategory === category?.value
                ? 'bg-primary text-white' :'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            <Icon name={category?.icon} size={18} />
            <span>{category?.label}</span>
          </button>
        ))}
      </div>

      {/* Content Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredContent?.map((item) => (
          <div key={item?.id} className="card overflow-hidden hover:shadow-lg transition-shadow">
            <div className="aspect-video bg-muted flex items-center justify-center relative">
              <img
                src={item?.url}
                alt={item?.title}
                className="w-full h-full object-cover"
              />
              {item?.approved && (
                <div className="absolute top-2 right-2 bg-green-600 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                  <Icon name="CheckCircle" size={14} className="mr-1" />
                  Aprobado
                </div>
              )}
            </div>
            <div className="p-4">
              <h3 className="font-semibold text-foreground mb-2">{item?.title}</h3>
              <div className="flex items-center justify-between text-sm text-muted-foreground mb-3">
                <span className="flex items-center">
                  <Icon name="FileType" size={16} className="mr-1" />
                  {item?.type}
                </span>
                <span>{item?.size}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Button size="sm" variant="outline" fullWidth iconName="Download">
                  Descargar
                </Button>
                <Button size="sm" fullWidth iconName="Share2">
                  Usar
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {filteredContent?.length === 0 && (
        <div className="card p-12 text-center">
          <Icon name="Inbox" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No hay contenido en esta categoría</p>
        </div>
      )}
    </div>
  );
};

export default ContentLibrary;
